import { defineComponent, h } from 'vue';
export default defineComponent({
    name: 'VxeIcon',
    props: {
        name: String,
        roll: Boolean,
        status: String
    },
    emits: [
        'click'
    ],
    setup: function (props, _a) {
        var emit = _a.emit;
        var clickEvent = function (evnt) {
            emit('click', { $event: evnt });
        };
        return function () {
            var name = props.name, roll = props.roll, status = props.status;
            return h('i', {
                class: ["vxe-icon-".concat(name), roll || '', status ? ["theme--".concat(status)] : ''],
                onClick: clickEvent
            });
        };
    }
});
